export default "__VITE_ASSET__R$Or5SXR__"